var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cards-list',{class:_vm.customClass,attrs:{"grid":_vm.grid,"gap":_vm.gap,"responsive":_vm.responsive}},_vm._l((Array.from(Array(+_vm.rows).keys())),function(sk,index){return _c('div',{key:index,staticClass:"skeleton mr-md-2",class:_vm.rowClass,style:(`height: ${_vm.height};`)})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }